//some utils goes here
// Converts image to canvas; returns new canvas element
import * as THREE from 'three';

export class Canvas2D {
  constructor(width, height) {
    this.width = width;
    this.height = height;
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.scale = 1;
    this.ctx = this.canvas.getContext("2d");
    this.offsetX = 0;
    this.offsetY = 0;
  }

  //根据传入的宽和高计算应该scale的比例，在原有的width和height上的比例缩放到此canvas的比例
  autoScale(width, height) {
    var widthScale = this.width / width;
    var heightScale = this.height / height;
    this.scale = heightScale > widthScale ? widthScale : heightScale; //取较小的缩放比例以免溢出
    this.scale = 0.7 * this.scale;
  }

  setOffset(offsetX, offsetY) {
    this.offsetX = offsetX;
    this.offsetY = offsetY;
  }

  //为点执行位移
  translatePoint(orgPoint) {
    var point = new Object();
    point.x = orgPoint.x;
    point.y = orgPoint.y;
    //在原点缩放,并反向
    point.x = this.scale * (point.x - this.offsetX);
    point.y = (-1) * this.scale * (point.y - this.offsetY);
    //平移到画布中心,周边要留一些空隙
    point.x = point.x + this.width / 2;
    point.y = point.y + this.height / 2;
    return point;
  }

  drawCircle(pos, arcStyle) {
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.arc(pos.x, pos.y, arcStyle.radius, 2 * Math.PI, false);
    this.ctx.fillStyle = arcStyle.color;
    this.ctx.fill();
    this.ctx.restore();
  }

  drawRect(pos, rectStyle) {
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.rect(pos.x, pos.y, rectStyle.width, rectStyle.height);
    this.setCtxStyle(rectStyle);
    this.ctx.restore();
  }

  drawLine(pointA, pointB, lineStyle, translate) {
    this.ctx.save();
    var ptA = pointA;
    var ptB = pointB;
    //在原点缩放
    if (translate) {
      ptA = this.translatePoint(pointA);
      ptB = this.translatePoint(pointB);
    }

    if (lineStyle == null || lineStyle.color == undefined || lineStyle.color == null) lineStyle.color = '#000';
    if (lineStyle.dotted) {
      this.ctx.setLineDash([5, 3]);
    } else {
      this.ctx.setLineDash([5, 0]);
    }

    if (lineStyle.lineWidth) {
      this.ctx.lineWidth = lineStyle.lineWidth;
    }
    this.ctx.beginPath();
    this.ctx.strokeStyle = lineStyle.color; //设置线的颜色状态
    this.ctx.fillStyle = lineStyle.color;
    this.ctx.moveTo(ptA.x, ptA.y);
    this.ctx.lineTo(ptB.x, ptB.y);
    this.ctx.stroke();
    this.ctx.restore();
  }

  drawText(text, pos, textStyle) {
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.font = "normal " + textStyle.size + "px 黑体";
    this.ctx.fillStyle = textStyle.color;
    this.ctx.fillText(text, pos.x, pos.y);   
    this.ctx.restore();
  }

  drawTrangleMark(point, height, text, style) {
    this.ctx.save();

    //先在原始坐标计算各点位置，然后在位移后的位置画出三角形,三角形尖角应朝上
    var ptB = this.translatePoint(point, 1);
    var ptL = {
      'x': ptB.x - height / 2,
      'y': ptB.y - height
    };
    var ptR = {
      'x': ptB.x + height / 2,
      'y': ptB.y - height
    };

    if (style == null || style.color == undefined || style.color == null) style.color = '#000';
    if (style.dotted) {
      this.ctx.setLineDash([5, 3]);
    } else {
      this.ctx.setLineDash([5, 0]);
    }

    this.ctx.beginPath();
    this.ctx.strokeStyle = style.color; //设置线的颜色状态
    this.ctx.fillStyle = style.color;
    this.ctx.moveTo(ptB.x, ptB.y);
    this.ctx.lineTo(ptL.x, ptL.y);
    this.ctx.moveTo(ptL.x, ptL.y);
    this.ctx.lineTo(ptR.x, ptR.y);
    this.ctx.moveTo(ptR.x, ptR.y);
    this.ctx.lineTo(ptB.x, ptB.y);
    this.ctx.stroke();
    if (text != undefined && text != null) {
      this.ctx.font = "normal 10px 黑体";
      if (style.markabove) {
        this.ctx.fillText(text, ptB.x - 20, ptB.y - height - 3, 50);
      }

    }

    this.ctx.restore(); //重要，否则ctx会影响之前的设置一起变
  }

  drawArrow(ctx, fromX, fromY, toX, toY, theta, headlen, width, color) {
    theta = typeof(theta) != 'undefined' ? theta : 30;
    headlen = typeof(theta) != 'undefined' ? headlen : 10;
    width = typeof(width) != 'undefined' ? width : 1;
    color = typeof(color) != 'color' ? color : '#000';
    var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
      angle1 = (angle + theta) * Math.PI / 180,
      angle2 = (angle - theta) * Math.PI / 180,
      topX = headlen * Math.cos(angle1),
      topY = headlen * Math.sin(angle1),
      botX = headlen * Math.cos(angle2),
      botY = headlen * Math.sin(angle2);

    ctx.beginPath();
    var arrowX = fromX - topX,
      arrowY = fromY - topY;
    ctx.moveTo(arrowX, arrowY);
    ctx.moveTo(fromX, fromY);
    ctx.lineTo(toX, toY);
    arrowX = toX + topX;
    arrowY = toY + topY;
    ctx.moveTo(arrowX, arrowY);
    ctx.lineTo(toX, toY);
    arrowX = toX + botX;
    arrowY = toY + botY;
    ctx.lineTo(arrowX, arrowY);
    ctx.strokeStyle = color;
    ctx.lineWidth = width;
    ctx.stroke();

  }

  drawLengthMark(pointA, pointB, markVal) {
    this.ctx.save();
    var ptA = this.translatePoint(pointA);
    var ptB = this.translatePoint(pointB);

    //画竖线
    this.ctx.beginPath();
    this.ctx.moveTo(ptA.x, ptA.y + 5);
    this.ctx.lineTo(ptA.x, ptA.y + 20);

    this.ctx.moveTo(ptB.x, ptB.y + 5);
    this.ctx.lineTo(ptB.x, ptB.y + 20);
    this.ctx.stroke();
    //画箭头
    this.drawArrow(this.ctx, ptA.x, ptA.y + 12.5, ptB.x, ptB.y + 12.5, 30, 5, 1);
    this.drawArrow(this.ctx, ptB.x, ptB.y + 12.5, ptA.x, ptA.y + 12.5, 30, 5, 1);
    //画文字
    this.ctx.font = "normal 10px 黑体";
    var txtSize = this.ctx.measureText(markVal);
    var txtStart = ptA.x + (ptB.x - ptA.x - txtSize.width) / 2;
    this.ctx.rect(txtStart - 5, ptA.y + 10, txtSize.width + 10, 10);
    this.ctx.fillStyle = '#fff';
    this.ctx.fill();
    this.ctx.fillStyle = '#000';
    this.ctx.fillText(markVal, txtStart, ptA.y + 15, 50);

    this.ctx.restore(); //重要，否则ctx会影响之前的设置一起变
  }

  setCtxStyle(styleCfg) {
    if (styleCfg.strokeStyle) {
      this.ctx.strokeStyle = styleCfg.strokeStyle;
    }
    if (styleCfg.lineWidth) {
      this.ctx.lineWidth = styleCfg.lineWidth;
    }

    if (styleCfg.fillColor) {
      this.ctx.fillStyle = styleCfg.fillColor;
      this.ctx.fill();
    } else {
      this.ctx.stroke();
    }

  }
  get() {
    return this.canvas;
  }

}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/Canvas2D.js